export type CopyReferenceFeedbackReason = 'PRICE' | 'DELIVERY' | 'OTHER';
export type CopyFeedbackTrigger = 'COPY_ICON' | 'SELECTION';

export const COPY_REFERENCE_CLICKED_ACTION_TYPE = '1PO/CATALOG/copyReferenceClicked';
export const COPY_REFERENCE_FEEDBACK_REASON_CLICKED_ACTION_TYPE = '1PO/CATALOG/copyReferenceFeedbackReasonClicked';
export const COPY_REFERENCE_DISPLAYED_ACTION_TYPE = '1PO/CATALOG/copyReferenceDisplayed';

export interface PriceMatchRequest {
  referenceNumber: string;
  competitor: string;
  competitorPrice: string;
  quantityNeeded: string;
  email: string;
}

export interface CopyReferenceIdentity {
  ipn?: string;
  tresorCode?: string;
  basketId?: string;
  buyerId?: string;
  buyerRepository?: string;
}

export interface CopyReferenceFeedbackPayload extends CopyReferenceIdentity {
  referenceNumber: string;
  reason: CopyReferenceFeedbackReason;
  trigger: CopyFeedbackTrigger;
  timestamp: string;
}

/**
 * Snapshot data provided by the caller — the component fills in referenceNumber, trigger, url, and timestamp automatically.
 */
export interface CopyReferenceTrackingData extends CopyReferenceIdentity {
  vin?: string;
  vrn?: string;
  vehicleBrand?: string;
  vehicleModel?: string;
  country?: string;
  dealerType?: string;
  sellerBirCode?: string;
  stockConfirmedQuantity?: number;
  referenceType?: string;
  familyCode?: string;
  referenceLabel?: string;
  priceVatExcluded?: string;
  priceVatIncluded?: string;
}

export type CopyReferenceClickedPayload = CopyReferenceTrackingData & {
  referenceNumber: string;
  trigger: CopyFeedbackTrigger;
  url: string;
  timestamp: string;
};

export interface CopyReferenceDisplayed {
  referenceNumber: string;
}
